
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes-and-reflections",
      function () {
        return require("private-next-pages/notes-and-reflections/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notes-and-reflections"])
      });
    }
  